import { Checkbox, Label, TextInput } from 'flowbite-react';
import type { Dispatch, SetStateAction } from 'react';
import { useMemo, useState, type FC } from 'react';
import { HiSearch } from 'react-icons/hi';

type ILocalFilterProps = {
  uniqueItems: { name: string; length: number }[];
  title: string;
  data: string[];
  setData: Dispatch<SetStateAction<string[]>>;
};

const LocalFilter: FC<ILocalFilterProps> = ({
  uniqueItems,
  title,
  setData,
  data,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isShowAll, setIsShowAll] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  // Сортировка и фильтрация элементов по поисковому запросу
  const filteredItems = useMemo(() => {
    return uniqueItems
      .sort((a, b) => a?.name?.localeCompare?.(b?.name) ?? 0)
      .filter(({ name }) =>
        name?.toLowerCase?.().includes?.(searchTerm?.toLowerCase?.())
      );
  }, [uniqueItems, searchTerm]);

  return (
    <div className="divide-y p-2 text-sm">
      <button
        onClick={() => setIsOpen((prev) => !prev)}
        className={`flex w-full items-center justify-between p-1 font-semibold ${
          isOpen && 'pb-2'
        }`}
      >
        <span>{title}</span>
        <svg
          className={`h-6 w-6 shrink-0 transition-transform ${
            isOpen ? 'rotate-180' : ''
          }`}
          fill="currentColor"
          width={15}
          height={15}
          viewBox="0 0 20 20"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
            clipRule="evenodd"
          />
        </svg>
      </button>
      {isOpen && (
        <div className="p-1">
          <div className="p-1">
            <Checkbox
              onChange={(event) =>
                setData(
                  event.target.checked
                    ? uniqueItems.map(({ name }) => name)
                    : []
                )
              }
              checked={data.length === uniqueItems.length}
              id={`all-${title}`}
            />
            <Label className="ml-1" htmlFor={`all-${title}`}>
              Выбрать все
            </Label>
          </div>
          <div className="mb-2 p-1">
            <TextInput
              id={`search-${title}`}
              type="text"
              placeholder="Поиск..."
              value={searchTerm}
              onKeyDown={(e) => e.stopPropagation()}
              onChange={(e) => {
                e.preventDefault();
                console.log('Search term:', e.target.value);
                setSearchTerm(e.target.value);
              }}
              icon={HiSearch}
              className="mb-1"
            />
          </div>
          {filteredItems
            .slice(0, isShowAll ? filteredItems.length : 4)
            .map(({ name, length }) => (
              <div className="p-1" key={name}>
                <Checkbox
                  onChange={(event) =>
                    setData((prev) =>
                      event.target.checked
                        ? [...prev, name]
                        : prev.filter((item) => item !== name)
                    )
                  }
                  checked={data?.includes?.(name)}
                  id={name}
                />
                <Label className="ml-1" htmlFor={name}>
                  {name} ({length})
                </Label>
              </div>
            ))}
          <button
            className="mt-2 text-cyan-600 dark:text-cyan-500"
            onClick={() => setIsShowAll((prev) => !prev)}
          >
            {isShowAll ? 'Сollapse' : 'View all'}
          </button>
        </div>
      )}
    </div>
  );
};

export default LocalFilter;
